export enum HoldingDiscriminator {
  Asset = 1,
  Fund = 2
}

// tslint:disable-next-line:no-namespace
export namespace HoldingDiscriminator {
  export function toString(discriminator: HoldingDiscriminator, inSentence: boolean = false): string {
    let text: string = null;
    switch (discriminator) {
      case HoldingDiscriminator.Asset:
        text = 'Asset';
        break;
      case HoldingDiscriminator.Fund:
        text = 'Fund';
        break;
      default:
        return null;
    }
    return inSentence ? text?.toLowerCase() : text;
  }

  export function parse(str: string): HoldingDiscriminator {
    return HoldingDiscriminator[str];
  }
}

export default HoldingDiscriminator;
